import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDialogSessionOptional } from '@/features/DialogSession';

type Props = {
  audioDuration: number;
};

/**
 * Отрезок записи, открытой на правку в расшифровке: следует за вводимыми границами и цветом
 * отличается от отметок пауз, перебиваний и говорящих.
 */
export const EditedIntervalHighlight: FC<Props> = ({ audioDuration }) => {
  const { t } = useTranslation('dialogs');
  const editedInterval = useDialogSessionOptional()?.editedInterval;
  const totalDurationMs = audioDuration * 1000;

  if (!editedInterval || !totalDurationMs) {
    return null;
  }

  // Границы, введённые за концом записи, прижимаются к её краю — отрезок не уходит за шкалу
  const startPercent = Math.min(editedInterval.startedAt / totalDurationMs, 1) * 100;
  const endPercent = Math.min(editedInterval.finishedAt / totalDurationMs, 1) * 100;

  return (
    <div className="absolute inset-0 pointer-events-none z-20">
      <div
        role="img"
        aria-label={t('transcriptEdit.editedIntervalOnTimeline')}
        // Минимальная ширина — чтобы запись нулевой длительности тоже была видна на шкале
        className="absolute top-0 bottom-0 min-w-0.5 rounded-md border-2 border-success-border bg-success-border/25"
        data-edited-interval-ms={`${editedInterval.startedAt}-${editedInterval.finishedAt}`}
        style={{ left: `${startPercent}%`, width: `${endPercent - startPercent}%` }}
      />
    </div>
  );
};
